import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

export interface ShowcaseRoute {
  path: string;
  label: string;
}

@Component({
  selector: 'maximizer-showcase-route-list-page',
  standalone: true,
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './route-list.page.html',
  styleUrl: './route-list.page.scss',
})
export class RouteListPage {
  readonly routes: ShowcaseRoute[] = [
    { path: 'activity-tracker', label: 'Activity Tracker' },
    { path: 'targets', label: 'Targets' },
    { path: 'insights', label: 'Insights' },
    { path: 'sales-intelligence', label: 'Sales Intelligence' },
    { path: 'ai-hub', label: 'AI Hub' },
    { path: 'ai-hub-fse-plus', label: 'AI Hub FSE Plus' },
    { path: 'ai-hub-sle-plus', label: 'AI Hub SLE Plus' },
    { path: 'workflow', label: 'Workflow' },
    { path: 'workflow-fse-plus', label: 'Workflow FSE Plus' },
    { path: 'workflow-sle-plus', label: 'Workflow SLE Plus' },
    { path: 'opportunities', label: 'Opportunities' },
    { path: 'cases', label: 'Cases' },
    { path: 'client-service', label: 'Client Service' },
    { path: 'bi-analysis', label: 'BI Analysis' },
    { path: 'family-tree', label: 'Family Tree' },
    { path: 'investments', label: 'Investments' },
    { path: 'insurance', label: 'Insurance' },
  ];
}
